import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import profileImage from '../assets/images/profile.png';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src= {profileImage} alt="" className="round-image "/>
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/Farshini" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/farshini-dev" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Farshini</h1>
          <p>Senior Full Stack Developer — Laravel | Next.js | React.js | PostgreSQL | REST API</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/Farshini" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://linkedin.com/in/farshini-dev" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;